import { useSyncExternalStore } from 'react'
import { type AuthTokens, tokenStore } from 'src/queries/tokenStore'

/**
 * Subscribes to the five session tokens on the reactive `tokenStore` seam. The
 * server snapshot resolves the SSR request-scoped context — see src/queries/AGENTS.md
 * for the read/write contract.
 */
export const useAuthTokens = (): AuthTokens =>
  useSyncExternalStore(
    tokenStore.subscribe,
    tokenStore.getSnapshot,
    tokenStore.getSnapshot,
  )
